export class AdministrativeRegionStore {
  constructor(private readonly _baseUrl: string) {}

  public index(): string {
    return `${this._baseUrl}/administrative-regions/`;
  }

  public detail(administrativeRegionId: number): string {
    return `${this._baseUrl}/administrative-regions/${administrativeRegionId}`;
  }

  public administrativeDistricts(): string {
    return `${this._baseUrl}/administrative-regions/administrative-districts`;
  }

  public postalCodes(): string {
    return `${this._baseUrl}/administrative-regions/postal-codes`;
  }

  public careServiceAreas(): string {
    return `${this._baseUrl}/administrative-regions/care-service-areas`;
  }
}
